import { useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { generateRoutesFromDate } from "../../infrastructure/redux/PlanningThunks";
import { toast } from "sonner";

export const GenerateRoutesButton = () => {
  const { t } = useTranslation("common");
  const { date } = useAppSelector((state) => state.planning);
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleGenerateRoutes = async () => {
    setIsLoading(true);
    try {
      const response = await dispatch(generateRoutesFromDate(date));
      const amount = Number(response.payload);

      if (!isNaN(amount)) {
        if (amount > 0) {
          toast.success(
            t("There are {{amount}} request connected to routes", {
              amount,
            }),
          );
        } else {
          toast.error(t("No routes generated"));
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      className="btn-sm w-100"
      onClick={() => void handleGenerateRoutes()}
      disabled={isLoading}
    >
      {isLoading ? t("Generating...") : t("Generate routes")}
    </Button>
  );
};
